export class Order {
  constructor(
    private _id: string,
    private _estimateId: string = null,
    private _customerId: string = null,
    private _shopId: string = null,
    private _labId: string = null,
    private _userId: string = null,
    private _paymentId: string = null,
    private _state: string,
    private _creationDate: Date = null,
    private _idInvoice: number = null,
    private _idPdfInvoice: string = null,
    private _agentId: string = null,
    private _signedPolicyUrl: string = null,
    private _idKasko: string = null,
    private _mshpId: string = null,
  ) { }

  get id(): string {
    return this._id;
  }

  get state(): string {
    return this._state;
  }

  get creationDate(): Date {
    return this._creationDate;
  }

  get customerId(): string {
    return this._customerId;
  }

  get shopId(): string {
    return this._shopId;
  }

  get labId(): string {
    return this._labId;
  }

  get userId(): string {
    return this._userId;
  }

  get paymentId(): string {
    return this._paymentId;
  }

  get estimateId(): string {
    return this._estimateId;
  }

  get idInvoice(): number {
    return this._idInvoice;
  }

  get idPdfInvoice(): string {
    return this._idPdfInvoice;
  }

  get agentId(): string {
    return this._agentId;
  }

  get mshpId(): string {
    return this._mshpId;
  }

  get signedPolicyUrl(): string {
    return this._signedPolicyUrl;
  }

  get idKasko(): string {
    return this._idKasko;
  }


  static fromRaw(orderRaw): Order {
    return new Order(
      orderRaw.key,
      orderRaw.data.id_estimate,
      orderRaw.data.id_customer,
      orderRaw.data.shop_id,
      orderRaw.data.lab_id,
      orderRaw.data.user_id,
      orderRaw.data.id_payment,
      orderRaw.data.state,
      new Date(orderRaw.data.creation_date._seconds * 1000),
      orderRaw.data.id_invoice,
      orderRaw.data.id_pdf_invoice,
      orderRaw.data.agent_id,
      orderRaw.data.signed_policy_url,
      orderRaw.data.id_kasko,
      orderRaw.data.mshp_id
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/order.ts